module.exports = __webpack_public_path__ + "static/media/money-bag.4a168eac.svg";